export default __webpack_public_path__ + "static/media/park_linowy_regulamin.70832508.pdf";